import React from 'react';

import { useModal } from '@tager/web-components';

import { ButtonsPanel } from '@/components/ButtonsPanel';
import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import ApplicationFormModal from '@/components/modals/ApplicationFormModal';
import { handleSubmitCarCatalogForm } from '@/utils/forms';
import { StyledOverlay } from '@/components/modals/shared/StyledOverlay';
import useSettingItem from '@/hooks/useSettingItem';
import { getDealersOptions } from '@/modules/Catalog/Catalog.helper';

function BottomPanel() {
  const openModal = useModal();
  const page = useTypedSelector(selectSinglePost);
  const catalogMainGoogleEvent = useSettingItem('CATALOG_MAIN_GOOGLE_EVENT');
  const catalogMainPartnerCarGoogleEvent = useSettingItem(
    'CATALOG_MAIN_PARTNER_CAR_GOOGLE_EVENT'
  );

  if (!page || !page.carStock) {
    return null;
  }

  const handleOpenApplicationFormModal = () => {
    openModal(
      ApplicationFormModal,
      {
        title: 'Хочу похожее авто',
        fieldsConfig: {
          dealers:
            page.carStock && !page.carStock.isPartnerCar
              ? getDealersOptions(page.carStock.dealers)
              : undefined,
        },
        onSubmit: (values) =>
          handleSubmitCarCatalogForm(
            {
              ...values,
              model: `${page.carStock?.brand.name} ${page.carStock?.model.name}`,
              dealer:
                values.dealer && !page.carStock?.isPartnerCar
                  ? values.dealer.value
                  : undefined,
            },
            {
              type:
                (page.carStock?.isPartnerCar
                  ? catalogMainPartnerCarGoogleEvent
                  : catalogMainGoogleEvent) ?? '',
              params: {
                car: `${page.carStock?.brand.name} ${page.carStock?.model.name}`,
              },
            }
          ),
      },
      { components: { Overlay: StyledOverlay }, scrollLockDisabled: true }
    );
  };

  return (
    <ButtonsPanel
      buttons={[
        page.carStock.quantity || page.carStock.preorderQuantity
          ? {
              title: page.carStock.quantity
                ? `Авто в наличии (${page.carStock.quantity})`
                : `Под заказ (${page.carStock.preorderQuantity})`,
              link: `/cars/new/${page.carStock.brand.urlAlias}/${page.carStock.model.urlAlias}`,
            }
          : {
              title: 'Хочу похожее авто',
              onClick: handleOpenApplicationFormModal,
            },
      ]}
    />
  );
}

export default BottomPanel;
